/// <amd-module name="Repos/Views/CommitHub/Discussion/CommitDiscussionIntegrationService" />
import {
    ArtifactDiscussionIntegrationService,
    IArtifactDiscussionIntegrationService
} from "Repos/Artifact/Discussion/ArtifactDiscussionIntegrationService";
import { IArtifactDiscussionThreadService } from "Repos/Artifact/Discussion/ArtifactDiscussionThreadService";
import { getMarkdownEditorProps } from "Repos/Artifact/Discussion/CommonMarkdownProps";
import { IDiscussionMarkdownEditorProps } from "Repos/Discussion/DiscussionThread.Types";
import { IVssPageContext, Services } from "VSS/Platform/Context";
import { getCommitDiscussionService } from "./CommitDiscussionThreadService";

export interface ICommitDiscussionIntegrationService extends IArtifactDiscussionIntegrationService {}

class CommitDiscussionIntegrationService extends ArtifactDiscussionIntegrationService implements ICommitDiscussionIntegrationService {
    protected getDiscussionStore(pageContext: IVssPageContext): IArtifactDiscussionThreadService {
        return getCommitDiscussionService(pageContext);
    }

    protected getMarkdownEditorProps(): IDiscussionMarkdownEditorProps {
        return getMarkdownEditorProps("ms.vss-code-web.commit-detail-markdown-commands");
    }
}

const serviceName = "ICommitDiscussionIntegrationService";
Services.add(serviceName, { serviceFactory: CommitDiscussionIntegrationService });

export function getDiscussionIntegrationService(pageContext: IVssPageContext): ICommitDiscussionIntegrationService {
    return pageContext.getService<ICommitDiscussionIntegrationService>(serviceName);
}
